import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { id, form, submitBtn } = data;
        const payload = { id, perc: Number(form.perc.value) };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/discounts/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Discount updated successfully.`
            });
            APP_COMPONENTS.discountForm.updateCode(response.code);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
